module.exports = __webpack_public_path__ + "static/colloidlefirst-ce2e64393c41d098a2c15a856b23b0bd.jpg";